import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path opacity=".4" d="M3 16v5h5l9.787-9.742-5.045-5.044L3 16z" fill="currentColor" /><path d="M20.414 5.814l-2.228-2.228a2 2 0 00-2.832.003l-2.613 2.625 5.045 5.045 2.625-2.613a2 2 0 00.003-2.832zM21 21.75h-7a.75.75 0 010-1.5h7a.75.75 0 010 1.5z" fill="currentColor" /></svg>);